<template>
  <div id="serviceDetail" v-title :data-title="service.name?service.name:''">
    <template v-if="hasAuth">
      <div class="service-container">
        <!--   收藏   -->
        <b class="collect" @click.stop="onCollectHandle">
          <van-icon class="iconfont" class-prefix="icon" :name="collect? 'collection-fill' : 'collection'"></van-icon>
        </b>
        <h4>{{ service.name }}</h4>
        <h6 class="color999">事项编号:{{ service.code?service.code:defaultValue }}<em></em>{{ service.bt?service.bt:defaultValue }}次访问</h6>
        <p class="text-overflow">服务人群：{{ serviceExtends.roleName || defaultValue }}</p>
        <p class="text-overflow">服务权限：{{
            service && service.auth && service.auth.roleName ? service.auth.roleName : '不详'
          }}</p>
        <p class="text-overflow">所属部门：{{ service.deptName }}</p>
        <p class="text-overflow">服务日期：{{ expiryDate }}</p>
        <!--   button   -->
        <div :class="['service-btn-box', {'height-auto' : btnBoxOpen}]">
          <van-button :disabled="access(item)[1]" block v-for="(item, index) in banliBtns" :key="index"
                      @click="btnClickHandler(item.blmurl,access(item)[1])">{{ item.blname }}
          </van-button>
        </div>
        <!--   控制button显示隐藏   -->
        <p :class="['toggle-icon', {'close': btnBoxOpen}]" v-if="banliBtns.length > 2">
          <van-icon class="iconfont" class-prefix="icon" name="enterinto"
                    @click.native="btnBoxOpen = !btnBoxOpen"></van-icon>
        </p>
      </div>
      <template v-if="showExtends">
        <div class="base-info service-info">
          <h4>基本信息</h4>
          <p>办理方式：{{ serviceExtends.applyType || defaultValue }}</p>
          <p>事项性质：{{ serviceExtends.serviceType || defaultValue }}</p>
          <p>办理途径：{{ serviceExtends.entry || defaultValue }}</p>
          <p>办理时间：{{ serviceExtends.serviceRoutine || '-' }}</p>
          <p>咨询电话：{{ serviceExtends.contactNumber || defaultValue }}</p>
          <p>监督电话：{{ serviceExtends.supervisionNumber || defaultValue }}</p>
        </div>
        <div class="service-info" v-for="(item,index) in serviceExtends.extends" :key="index" v-image-preview>
          <h4>{{ item.name }}</h4>
          <img v-if="item.img && item.img.position == 'top'" :src="complete(item.img.url)"/>
          <template v-if="item.type == 'text'">
            <template v-if="item.detail.length">
              <p v-for="(detailItem,detailIndex) in item.detail" :key="detailIndex">{{ detailIndex + 1 }}：{{
                  detailItem.text
                }}</p>
            </template>
          </template>
          <template v-if="item.type == 'attach'">
            <template v-if="item.detail.length">
              <p v-for="(detailItem,detailIndex) in item.detail" :key="detailIndex">
                <span v-if="detailItem.detail" class="download-link"
                      @click="onPreviewFile(detailItem.detail.fileType,detailItem.detail.downloadUrl)">
                  <i
                      :class="
                        [
                            'fileIcon',
                            detailItem.detail && detailItem.detail.fileType && fileIcons.indexOf(detailItem.detail.fileType) >= 0? detailItem.detail.fileType : 'unknown'
                        ]"></i>
                  {{ detailIndex + 1 }}：{{ detailItem.text }}
                </span>
                <span v-else class="download-link" @click="downloadFail">
                          <i class="fileIcon unknown"></i>
                          {{ detailIndex + 1 }}、{{ detailItem.text }}
                </span>
              </p>
            </template>
          </template>
          <template v-if="item.type == 'table'">
            <template v-if="item.detail && item.detail.length>0">
              <div class="about-dept" v-for="(deptItem,num) in item.detail" :key="num">
                <p v-for="(subItem,idx) in item.header" :key="idx"><label>{{subItem.name}}：</label>{{deptItem[subItem.key]}}</p>
              </div>
            </template>
          </template>
          <img v-if="item.img && (item.img.position == 'bottom' || !item.img.position)" :src="complete(item.img.url)"/>
        </div>
      </template>
      <div class="service-info">
        <h4>其他说明</h4>
        <div v-html="service.desc" class="panel-intro text-rich" v-image-preview></div>
      </div>
      <div class="detail-tabbar" v-if="showTabbar">
        <div class="tabbar-item" v-if="showFeedback" @click="locationTo(service.service[0].blmurl)">
          <div class="icon-box">
            <van-icon class="iconfont" class-prefix="icon" name="editor"></van-icon>
          </div>
          <span>意见反馈</span>
        </div>
        <div class="tabbar-item" v-if="showOnlineConsult" @click="locationTo(`weixin/weui/quanzi.html#list/${service.quanziId}/quanzi`)">
          <div class="icon-box">
            <van-icon class="iconfont" class-prefix="icon" name="message"></van-icon>
          </div>
          <span>我要咨询</span>
        </div>
        <div class="tabbar-item" v-if="showYuyue" @click="locationTo(`weixin/weui/yuyue.html#yuyue/${id}`)">
          <div class="icon-box">
            <van-icon class="iconfont" class-prefix="icon" name="time"></van-icon>
          </div>
          <span>在线预约</span>
        </div>
      </div>
    </template>
    <Error :type="'forbidden'" v-else></Error>
  </div>
</template>

<script>
import {Toast,Dialog} from 'vant';
import {queryServiceExtends, queryService,favService,cancelFavService,increaseHandle} from "@/api/service-hall";
import {previewFile, parseFileType, previewImage, FILE_TYPE_IMAGE} from '@/utils/file'
import {complete, locationTo, baseURL} from "@/utils/url"
import {forward} from "@/utils/serviceUtil"
import {formatDateTime} from "@/utils/dateTimeUtil"
import moment from 'moment'

export default {
  name: "ServiceDetail",
  props: ['id'],
  data() {
    return {
      //button 是否展开
      btnBoxOpen: false,
      showExtends:false,
      service: {},
      serviceExtends: {},
      defaultValue: '暂无',
      fileIcons: ['doc', 'docx', 'gif', 'jpg', 'pdf', 'png', 'ppt', 'pptx', 'rar', 'txt', 'xls', 'xlsx', 'zip'],
      userId:'',
      roleName:'',
      parseExpiryDate:['','长期有效','每日','每月','每年'],
      hasAuth: true,
      isShowFeedbackAndOnlineConsult: {}
    }
  },
  computed: {
    collect(){
      return this.service.isf == '1';
    },
    showBanli() {
      // 是否显示在线办理
      // 无权限、未启用、已停用三种状态显示在页面上
      return this.service.service[2].blisuse === "true"
    },
    banliBtns() {
      if(this.service.service){
        return this.service.service[2].blArr && this.service.service[2].blArr.filter(item => item.blmurl)
      }
      return [];
    },
    visitorAuth() {
      // 是否有访客权限（当前用户为访客且服务为访客服务）
      return this.userId == "visitor" && this.service.isVisitor == "true"
    },
    showFeedback() {
      return !this.visitorAuth                                        // 访客不显示
          && this.hasAuth                                             // 判断权限
          && this.isShowFeedbackAndOnlineConsult.feedBack == "true"   // 判断系统参数
          && this.service.service[0].fkisuse == "true"                // 判断意见反馈是否开启
          && this.service.service[0].blmurl                           // 判断意见反馈是否为空
    },
    showOnlineConsult() {
      return !this.visitorAuth                                            // 访客不显示
          && this.hasAuth                                             // 判断权限
          && this.isShowFeedbackAndOnlineConsult.onlineConsult == "true"  // 判断系统参数
          && this.service.service[1].zxisuse == "true"                    // 判断在线咨询是否开启
    },
    showYuyue() {
      let arr = this.service;
      if (arr && arr.service) {
        return !this.visitorAuth                        // 访客不显示
            && this.hasAuth                                             // 判断权限
            && arr
            && arr.service[3].yyisuse == "true"   // 判断在线预约是否开启
      } else {
        return false
      }
    },
    showTabbar(){
      return this.showFeedback || this.showOnlineConsult || this.showYuyue;
    },
    expiryDate(){
      return this.parseExpiryDate[parseInt(this.service.expiryDate)];
    }
  },
  created() {
    this.mixinShowLoading();
    //请求服务详情页数据
    queryService(this.id)
        .then(resp => {
          if (!resp.item.stats) {
            Dialog.alert({message: '当前服务已停用！',})
            return;
          }
          this.canPraise = resp.canPraise
          this.isShowFeedbackAndOnlineConsult = typeof resp.isShowFeedbackAndOnlineConsult === "string"?JSON.parse(resp.isShowFeedbackAndOnlineConsult):resp.isShowFeedbackAndOnlineConsult;
          this.service = resp.item
          this.roleName = resp.roleName
          this.userId = resp.userId
          this.showExtends = resp.item.extends && resp.item.extends.hasOwnProperty('isOpenExtends') && resp.item.extends.isOpenExtends !== 'false';
          this.hasAuth = resp.item.hasAuth;
          var extend = [];
          queryServiceExtends(this.id).then(resp => {
            this.serviceExtends = resp.data || null;
            if (this.showExtends) {
              this.serviceExtends.extends.forEach((item) => {
                (item.detail.length || item.img) && extend.push(item);
              });
            }
            this.serviceExtends.extends = extend;
          })
        })
        .catch(error => {
          console.log(error)
          this.mixinPageNetError("请求服务失败");
        })
        .finally(() => {
          // TODO：处理请求完成后结果
          this.mixinClearLoading();
        })
  },
  methods: {
    onCollectHandle(){
      if (this.service.isf == '1')
        cancelFavService(this.id).then(() => {
          this.service.isf = '0'
          Toast('取消收藏成功')
        })
      else
        favService(this.id).then(() => {
          this.service.isf = '1'
          Toast('收藏服务成功')
        })
    },
    access() {
      return function (item) {
        // TODO: 判断状态变灰不能点击
        let startDate = this.service.startDate
        let endDate = this.service.endDate
        let nowDate = moment().unix() * 1000
        if (this.service.hasAuth !== 'true' || item.visitorFlow === false) {
          return ["无权限", true]
        } else if (!this.service.stats) {
          return ['已停用', true]
        } else if (endDate && endDate !== '' && endDate < nowDate) {
          return ['已停用', true]
        } else if (startDate && startDate !== '' && startDate > nowDate) {
          return ['未启用', true]
        } else {
          return ['进入', false]
        }
      }
    },
    btnClickHandler(blUrl, isDisabled) {
      !isDisabled && increaseHandle(this.id).finally(() => forward(this.service, blUrl))
    },
    onPreviewFile(fileType, downloadUrl) {
      if (parseFileType(fileType.toLowerCase()) === FILE_TYPE_IMAGE) {
        previewImage([complete(downloadUrl)]);
      } else {
        previewFile(parseFileType(fileType.toLowerCase()), downloadUrl)
      }
    },
    formatDateTime, locationTo,complete,forward
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme";

#serviceDetail {
  overflow: hidden;
}

.service-container, .service-info {
  padding: 15px;
  margin: 12px 15px;
  background: #fff;
  border-radius: 5px;
  position: relative;
  img{
    width:100%;
  }
  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  h4 {
    line-height: 38px;
    margin-right: 35px;
    font-weight: 500;
    color: $c333;
    @extend .font18;
  }

  h6 {
    line-height: 28px;
    font-weight: 500;
    @extend .font13;

    span {
      display: inline-block;
      margin-left: 20px;
    }
    em{
      display: inline-block;
      width: 1.5em;
    }
  }

  p {
    line-height: 27px;
    color: $c333;
    @extend .font14;
  }

  .service-btn-box {
    max-height: 100px;
    overflow: hidden;
    margin-top: 20px;

    button {
      height: 42px;
      line-height: 42px;
      background: var(--main-color);
      color: #fff;
      border: none;
      border-radius: 5px;
      margin-top: 12px;
      @extend .font16;
      span{
        display: block;
        height: 42px;
        line-height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:first-child {
        margin-top: 0;
      }
    }

    &.height-auto {
      max-height: inherit;
    }
  }

  .toggle-icon {
    width: 45px;
    height: 18px;
    margin: 0 auto;
    position: relative;

    .iconfont {
      font-size: 18px;
      position: absolute;
      left: 50%;
      top: 0;
      margin-left: -9px;
      transform: rotate(90deg);
      color: var(--main-color);
    }

    &.close .iconfont {
      transform: rotate(-90deg);
    }
  }

  .collect {
    display: flex;
    align-content: center;
    text-align: center;
    justify-content:center;
    width: 35px;
    height: 50px;
    background: #f5b86f;
    position: absolute;
    top: 0;
    right: 15px;
    padding-top:10px;
    box-sizing: border-box;
    .iconfont {
      font-size: 22px;
      color: #fff;
    }

    &:after {
      content: '';
      display: block;
      border-left: 18px solid transparent;
      border-right: 18px solid transparent;
      border-top: 10px solid transparent;
      border-bottom: 10px solid #fff;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .about-dept{
    padding: 8px 0;
    border-bottom: 1px solid #F0F0F0;
    p{
      display: flex;
      min-height: 30px;
      line-height: 30px;
      @extend .font14;
      label{
        white-space: nowrap;
      }
    }
  }
  .panel-intro {
    color: #999;
    text-align: justify;
    line-height: 1.5;
    margin-bottom: 20px;
    @extend .font13;
  }
}
.download-link{
  color: #1678FF;
}

.detail-tabbar {
  height: 50px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: content-box;
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;

  .tabbar-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    color: #646566;
    line-height: 1;
    cursor: pointer;
    @extend .font12;
    .icon-box {
      text-align: center;
      .iconfont {
        font-size: $base-fontsize24;
      }
    }
    span {
      @extend .font14;
    }
  }
}
.empty{
  margin-top: 100px;
}
</style>
